module.exports = __webpack_public_path__ + "img/1.549e1e19.png";